import { useEffect, useRef } from 'react'
import type { AttentionItem } from './api'
import { phrase, type SectionKey } from './model'
import { snoozeAttention } from './attn'

export function Attention({
  pastDue,
  dueSoon,
  onOpen,
  onClose,
}: {
  pastDue: AttentionItem[]
  dueSoon: AttentionItem[]
  onOpen: (section: SectionKey, id: string) => void
  onClose: () => void
}) {
  const ref = useRef<HTMLDialogElement>(null)
  useEffect(() => {
    const d = ref.current
    if (d && !d.open) d.showModal()
  }, [])

  const snooze = () => {
    snoozeAttention()
    onClose()
  }

  const group = (title: string, items: AttentionItem[]) =>
    items.length === 0 ? null : (
      <div className="res" key={title}>
        <h4>
          {title} · {items.length}
        </h4>
        {items.map((x) => (
          <button
            type="button"
            className="mini"
            key={x.type + x.id}
            onClick={() => {
              onOpen(x.type as SectionKey, x.id)
              onClose()
            }}
          >
            <span>{x.name}</span>
            <span>{phrase(x.days)}</span>
          </button>
        ))}
      </div>
    )

  return (
    <dialog
      ref={ref}
      onCancel={(e) => {
        e.preventDefault()
        onClose()
      }}
    >
      <div className="form">
        <h3>Needs attention</h3>
        <p className="k">Overdue, or due within 14 days. Click a line to open it.</p>
        {group('Past due', pastDue)}
        {group('Due soon', dueSoon)}
        <div className="row">
          <button type="button" className="btn" onClick={snooze}>
            Remind me tomorrow
          </button>
          <button type="button" className="btn p" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </dialog>
  )
}
